import { useEffect } from "react";

export const SITE_URL = "https://autoescuelasfaro.com";

export const SOCIAL_PROFILES = [
  "https://www.instagram.com/autoescuelasfaro/",
  "https://www.facebook.com/autoescuelasfaro/",
  "https://www.tiktok.com/@autoescuelasfaro",
  "https://share.google/lA8xBXGoPt2RPNGuh",
];

export const DEFAULT_OG_IMAGE = `${SITE_URL}/assets/og/autoescuelas-faro-vigo.jpg`;

export const ogFromAsset = (p) =>
  p ? `${SITE_URL}/assets/og/${p.split("/").pop().replace(/\.(webp|png|jpe?g)$/i, "")}.jpg` : undefined;

function upsertMeta(attr, key, content) {
  let m = document.querySelector(`meta[${attr}="${key}"]`);
  if (!m) {
    m = document.createElement("meta");
    m.setAttribute(attr, key);
    document.head.appendChild(m);
  }
  m.setAttribute("content", content);
}

export function useSeo({ title, description, canonical, ogImage, ogImageAlt, extraMeta }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) upsertMeta("name", "description", description);
    if (canonical) {
      let l = document.querySelector('link[rel="canonical"]');
      if (!l) {
        l = document.createElement("link");
        l.setAttribute("rel", "canonical");
        document.head.appendChild(l);
      }
      l.setAttribute("href", canonical);
    }
    const img = ogImage
      ? (ogImage.startsWith("http") ? ogImage : `${SITE_URL}${ogImage}`)
      : DEFAULT_OG_IMAGE;
    const url = canonical || `${SITE_URL}${window.location.pathname}`;
    const pairs = [
      ["property", "og:title", title],
      ["property", "og:description", description],
      ["property", "og:url", url],
      ["property", "og:image", img],
      ["property", "og:image:width", "1200"],
      ["property", "og:image:height", "630"],
      ["property", "og:image:alt", ogImageAlt || "Autoescuelas Faro — autoescuela en Vigo desde 1980"],
      ["name", "twitter:card", "summary_large_image"],
      ["name", "twitter:title", title],
      ["name", "twitter:description", description],
      ["name", "twitter:image", img],
    ];
    for (const [attr, key, content] of pairs) {
      if (content) upsertMeta(attr, key, content);
    }
    if (extraMeta) {
      for (const [attr, key, content] of extraMeta) upsertMeta(attr, key, content);
    }
  }, [title, description, canonical, ogImage, ogImageAlt, extraMeta]);
}

export const JsonLd = ({ data }) => {
  // "<" escaped so prerendered static HTML can never break out of the script context
  const json = JSON.stringify(data).replace(/</g, "\\u003c");
  useEffect(() => {
    let parsed;
    try { parsed = JSON.parse(json); } catch (e) { parsed = null; }
    const type = parsed && parsed["@type"];
    const nodes = type ? Array.from(document.querySelectorAll('script[type="application/ld+json"]')) : [];
    let s = nodes.find((el) => { try { return JSON.parse(el.textContent)["@type"] === type; } catch (e) { return false; } });
    if (!s) { s = document.createElement("script"); s.type = "application/ld+json"; document.head.appendChild(s); }
    s.textContent = json;
    return () => s.remove();
  }, [json]);
  return null;
};
